import script from "./MyPoolBalancesCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyPoolBalancesCard.vue?vue&type=script&setup=true&lang=ts"

import "./MyPoolBalancesCard.vue?vue&type=style&index=0&id=81e6d5e6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81e6d5e6"]])

export default __exports__